import React, { useState, useEffect, useRef } from "react";
import { Navbar, NavbarHome, Main, Product } from "../components";
import { useSelector } from 'react-redux'
import Navigation from './../components/Navigations'
import Signature from './../assets/img/signature.svg';

import Header from "../components/header";
import BookCover from './../assets/img/book.jpg';
import Footer from './../components/Footer';
import { PostDataAPI } from "../components/services/ApiServices";
import { formatNumberComma } from "../components/services/extension";
import './../main.css';

function Home() {
  const cartlength = useSelector(state => state.handleCart);
  const playerRef = useRef(null);

  const [totalQuantity, setTotalQuantity] = useState(0);
  const [showSoldOutModal, setShowSoldOutModal] = useState(true);

  const loadQuantity = () => {
    const obj = {
      ProductId: 55
    }
    PostDataAPI('product/getCurrentQuantity', obj, true).then((result) => {
      if (result.success == true) {
        setTotalQuantity(result.data.quantity)
      }
    });
  }


  useEffect(() => {
    loadQuantity();
  }, [])


  useEffect(() => {
    const starsEl = document.getElementById("stars");

    for (let i = 0; i < 90; i++) {
      const s = document.createElement("div");
      s.className = "star";

      const sz = Math.random() * 2 + 0.5;

      s.style.cssText =
        "width:" +
        sz +
        "px;height:" +
        sz +
        "px;top:" +
        Math.random() * 100 +
        "%;left:" +
        Math.random() * 100 +
        "%;animation-delay:" +
        Math.random() * 5 +
        "s;animation-duration:" +
        (3 + Math.random() * 5) +
        "s;";

      starsEl.appendChild(s);
    }

    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e, i) => {
          if (e.isIntersecting)
            setTimeout(() => e.target.classList.add("visible"), i * 70);
        });
      },
      { threshold: 0.1 }
    );

    document.querySelectorAll(".fade-up").forEach((el) => obs.observe(el));
  }, []);


  return (
    <>
      <Header></Header>
      {showSoldOutModal && (
        <div className="sold-out-overlay" role="dialog" aria-modal="true" aria-labelledby="sold-out-title">
          <div className="sold-out-modal">
            <button
              type="button"
              className="sold-out-close"
              aria-label="Close"
              onClick={() => setShowSoldOutModal(false)}
            >
              ×
            </button>
            <h2 id="sold-out-title">All Books Sold Out</h2>
            <p>
              Thank you for the incredible response to
            </p>
            <p className="sold-out-highlight-line">
              Dreams from Our Founding Fathers – America 250
            </p>
            <p>
              Commemorative Edition.
            </p>
            <p>
              Our entire limited edition inventory has now been sold. We sincerely appreciate the overwhelming support and enthusiasm shown by readers across the country.
            </p>
            <p>
              Thank you for being part of this historic release.
            </p>
            <button
              type="button"
              className="sold-out-button"
              onClick={() => setShowSoldOutModal(false)}
            >
              Close
            </button>
          </div>
        </div>
      )}
      {/* NAV */}


      {/* LIMITED BANNER */}
      <div className="limited-banner">
        <div
          className="limited-banner-text"
          style={{
            fontSize: "clamp(20px,3vw,28px)",
            display: "block",
            marginBottom: "4px",
          }}
        >
          America 250 Commemorative Edition
        </div>

        <div
          style={{
            fontFamily: "'Cinzel',serif",
            fontSize: "clamp(14px,2.2vw,18px)",
            letterSpacing: ".18em",
            color: "rgba(255,255,255,0.9)",
            textTransform: "uppercase",
            marginBottom: "5px",
          }}
        >
          Limited to 1,776 Copies
        </div>

        <div
          style={{
            fontFamily: "'Cormorant Garamond',serif",
            fontSize: "clamp(13px,1.8vw,16px)",
            letterSpacing: ".12em",
            color: "var(--gold-pale)",
            fontStyle: "italic",
          }}
        >
          All personally signed and numbered by Governor Ron DeSantis
        </div>
      </div>

      {/* STAR FIELD */}
      <div className="stars" id="stars"></div>

      <section className="bookarea">
        <div className="container">
          <div className="row align-items-center m-auto">
            <div className="col-lg-6">
              <div className="pbody outStock_mobile">
                <b style={{ color: "#E5DEAF" }}>Only 1,776</b> copies will be printed,
                each one signed and individually numbered by{" "}
                <b style={{ color: "#E5DEAF" }}>Ron DeSantis</b>. This signed limited
                edition also includes a new introduction by America’s Governor.
              </div>
              <img src={BookCover} width={'450'} />
            </div>
            <div className="col-lg-6 col-sm-12 position-relative">

              <div>

                <div className="pbody outStock_desktop">
                  <b style={{ color: "#E5DEAF" }}>Only 1,776</b> copies will be printed,
                  each one signed and individually numbered by{" "}
                  <b style={{ color: "#E5DEAF" }}>Ron DeSantis</b>. This signed limited
                  edition also includes a new introduction by America’s Governor.
                </div>
                <h2>Dreams From Our <br></br>Founding Fathers</h2>
                <div className="">
                  <h3>
                    $250<span style={{fontSize:'1rem'}}>.00</span>
                  </h3>
                  <h4 style={{color:'#c9a84c'}}>Free Shipping</h4>
                  <p> ( Limited to 1,776 Copies)</p>
                  {/* <p style={{ color: 'yellow', fontSize: '19px', marginTop: 0 }}><span style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>{formatNumberComma(totalQuantity)}</span> copies remaining </p> */}

                  <button type="button" className="nav-btn hero_order_btn disabled-site-action" disabled>
                    SOLD OUT
                  </button>
                </div>

                <div className="signed_content">
                  <h3>Personally signed by Ron DeSantis</h3>
                  <img src={Signature} />
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>

      {/* HERO */}
  

      {/* QUOTE BAND */}
      <div className="quote-band">
        <p className="quote-text">
          "When leaders govern consistently with the Founders' vision and rely
          on time-tested principles, positive outcomes ensue."
        </p>
        <p className="quote-attr">
          — Ron DeSantis, Dreams From Our Founding Fathers
        </p>
      </div>

      {/* INTRODUCTION */}
      <section style={{ background: "var(--navy)" }}>
        <div className="intro-inner">
          <div className="section-label">The New Introduction</div>

          <h2 className="section-heading">
            Why This Book
            <br />
            <em>Matters Now More Than Ever</em>
          </h2>

          <div className="intro-grid">
            <div className="prose fade-up">
              <p>
                When <em>Dreams From Our Founding Fathers</em> was published
                more than a decade ago, Ron DeSantis — then a former Navy
                officer who had never sought nor won elected office — warned
                that the Obama impulse to "fundamentally transform the United
                States" represented a rejection of the nation's founding
                principles.
              </p>

              <p>
                If anything, the analysis undersold the sharp leftist turn that
                marked so much of the recent past — not just by the Democrat
                Party but also major institutions from universities to corporate
                America.
              </p>

              <p>
                In the fifteen years since, Ron DeSantis has witnessed the
                consistent betrayal of the nation's founding ethos by the
                entrenched political class — including judicial adventurism,
                profligate congressional borrowing and spending, administrative
                state weaponization, and public health authoritarianism.
              </p>
            </div>

            <div className="prose fade-up">
              <p>
                As a member of Congress, DeSantis spearheaded efforts to restore
                constitutional government, including by reining in the
                bureaucracy, imposing spending constraints on Congress, and
                enacting term limits.
              </p>

              <p>
                As the 46th governor of Florida, Ron DeSantis launched a
                counterrevolution against leftist orthodoxy that transformed
                Florida from a liberal-trending swing state to the most reliable
                conservative state in the nation.
              </p>

              <p>
                As Americans celebrate the nation's 250th birthday, the
                diverging results among the states illustrate that the Founders'
                vision continues to endure.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ========================= */}
      {/* PRINCIPLES (COMMENTED SECTION - KEPT EXACT) */}
      {/* ========================= */}

      {/*
      <section className="principles-bg">
        <div className="principles-inner">
          <div className="section-label">The Foundation</div>
          <h2 className="section-heading">The First Principles That Built<br><em>A Free Republic</em></h2>

          <div className="pcard fade-up">
            <div className="pnum">I</div>
            <div className="ptitle">Rights From God, Not Government</div>
            <div className="pbody">Our rights are endowed by our Creator — not granted by politicians, bureaucracies, or courts.
            No majority, no administration, and no act of Congress can legitimately strip away what Providence has given.</div>
          </div>

          <div className="pcard fade-up">
            <div className="pnum">II</div>
            <div className="ptitle">Rule of Law</div>
            <div className="pbody">Equal justice under a stable, written Constitution is the bedrock of the republic.</div>
          </div>

          <div className="pcard fade-up">
            <div className="pnum">III</div>
            <div className="ptitle">Limited Government</div>
            <div className="pbody">Power concentrated in Washington is power removed from the people.</div>
          </div>

          <div className="pcard fade-up">
            <div className="pnum">IV</div>
            <div className="ptitle">Individual Liberty</div>
            <div className="pbody">Free speech and liberty are non-negotiable birthrights.</div>
          </div>

        </div>
      </section>
      */}

      {/* ========================= */}
      {/* FLORIDA (COMMENTED SECTION - KEPT EXACT) */}
      {/* ========================= */}

      {/*
      <section className="florida-bg">
        <div className="florida-inner">
          <div className="section-label">The Proof of Concept</div>
          <h2 className="section-heading">The Free State of Florida:<br><em>First Principles in Action</em></h2>

          <p className="florida-lead">
            As the 46th Governor, Ron DeSantis governed Florida the way the Founders envisioned.
          </p>

          <div className="stats-grid">
            <div className="scard fade-up"><div className="snum">#1</div><div className="slabel">Economy</div></div>
            <div className="scard fade-up"><div className="snum">#1</div><div className="slabel">Education</div></div>
            <div className="scard fade-up"><div className="snum">$0</div><div className="slabel">Income Tax</div></div>
          </div>
        </div>
      </section>
      */}

      {/* AUTHOR */}
      <section className="author-bg">
        <div className="author-inner">
          <div className="section-label">About the Author</div>

          <h2 className="author-name">Ron DeSantis</h2>

          <div className="prose fade-up">
            <p>
              Ron DeSantis is the 46th Governor of the Free State of Florida.
              Before entering politics, he served in the United States Navy.
            </p>

            <p>
              As governor, DeSantis delivered what this book promised: proof
              that the Founders' vision works.
            </p>

            <p>
              This commemorative edition includes a new introduction reflecting
              on America’s 250th anniversary.
            </p>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="cta-section" id="order">
        <div className="cta-inner">
          <div className="cta-eyebrow">Secure Your Copy Today</div>

          <p className="cta-sub">
            Honoring 250 years of American liberty — printed in a strictly
            limited run.
          </p>

          <div className="cta-1776">
            <div className="cta-1776-num">1,776</div>
            <div className="cta-1776-sub">Numbered &amp; Signed Copies</div>
            <div className="cta-1776-line"></div>
            <div className="cta-1776-note">
              Each copy individually numbered and signed.
              <br />
              Includes a new introduction by Governor Ron DeSantis.
            </div>
          </div>

          <button type="button" className="btn-order disabled-site-action" disabled>
            SOLD OUT
          </button>

          <p className="order-note">
            Individually numbered · Limited to 1,776 copies total
          </p>
        </div>
      </section>

      <Footer></Footer>

    </>
  )
}

export default Home
